import { render, staticRenderFns } from "./SlotSelect.vue?vue&type=template&id=b410fcd6&scoped=true"
import script from "./SlotSelect.vue?vue&type=script&lang=js"
export * from "./SlotSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410fcd6",
  null
  
)

export default component.exports